import AXIOS from "@/axios";
import { APIResponse } from "@/types";
import {
  DownloadSchoolQuery,
  SchoolCourseTermAccessData,
  SchoolModel,
  SchoolQuery,
  SchoolRestrictionModel,
  UpdateSchoolCourseTermAccessPayload,
} from "@/types/school.model";
import { removeEmptyProps } from "@/utils/constants";
import moment from "moment";

interface CreateSchoolResponse {
  id: string;
  login_user: string;
  login_email: string;
  one_time_token: string;
  is_email_sent: boolean;
}

interface UpdateSchoolResponse {
  id: string;
  login_user: string;
  login_email: string;
}

export const getAllSchoolService = async (query: SchoolQuery) => {
  if (query.fromDate && query.toDate) {
    query.fromDate = moment(new Date(query.fromDate).toISOString()).format(
      "DD-MM-YYYY"
    );
    query.toDate = moment(new Date(query.toDate).toISOString()).format(
      "DD-MM-YYYY"
    );
  }

  return AXIOS.get<APIResponse<SchoolModel[]>>("/sch/api/v1/list", {
    params: removeEmptyProps(query),
  });
};

export const createSchoolService = async (payload: SchoolModel) => {
  return AXIOS.post<APIResponse<CreateSchoolResponse>>(
    "/sch/api/v1/add",
    payload
  );
};

export const updateSchoolService = async (
  schoolId: string,
  payload: SchoolModel
) => {
  return AXIOS.patch<APIResponse<UpdateSchoolResponse>>(
    `/sch/api/v1/update/${schoolId}`,
    payload
  );
};

export const deleteSchoolService = async (id: string) => {
  return AXIOS.delete<{ message: string }>(`/sch/api/v1/delete/${id}`);
};

export const getSchoolService = async (id: string) => {
  return AXIOS.get<APIResponse<SchoolModel>>(`/sch/api/v1/view/${id}`);
};

export const updateRestrictionService = async (
  payload: SchoolRestrictionModel
) => {
  return AXIOS.post<APIResponse<{ id: string }>>(
    `/sch/api/v1/restrict`,
    payload
  );
};

export const getSchoolCourseTermAccessService = async (schoolId: string) => {
  return AXIOS.get<APIResponse<SchoolCourseTermAccessData>>(
    `/sch/api/v1/${schoolId}/course-term-access`
  );
};

export const updateSchoolCourseTermAccessService = async (
  schoolId: string,
  payload: UpdateSchoolCourseTermAccessPayload
) => {
  return AXIOS.put<APIResponse<unknown>>(
    `/sch/api/v1/${schoolId}/course-term-access`,
    payload
  );
};

export const downloadSchoolService = async (
  type: "pdf" | "xl" | "csv",
  params: DownloadSchoolQuery
) => {
  if (params.fromDate && params.toDate) {
    params.fromDate = moment(new Date(params.fromDate).toISOString()).format(
      "DD-MM-YYYY"
    );
    params.toDate = moment(new Date(params.toDate).toISOString()).format(
      "DD-MM-YYYY"
    );
  }

  return AXIOS.get(`/sch/api/v1/dwnld/${type}`, {
    params: removeEmptyProps(params),
    responseType: "blob",
  });
};
